import React from 'react';
import styled from 'styled-components';
import type { IWidgetComponentProps } from '~packages/engine/src/schema/widgets/IWidgetType';
import { IPageWidget } from './IPageWidget';

const PageDivideWrapper = styled.div`
  width: 100%;
  height: 44px;
  position: relative;
  padding-top: 2px;
`;

const PageDividerIndicator = styled.div`
  width: 100%;
  border-bottom: 32px dashed ${props => props.theme.colorBorderSecondary};
  border-bottom: 32px dashed ${props => props.theme.colorPrimaryBg};

  &:hover {
    // all'hover evidensiamo la barra del container
    border-top-color: ${props => props.theme.colorPrimaryBg};
  }
`;
const PageDividerLabel = styled.div`
  position: absolute;
  top: 2px;
  height: 32px;
  display: inline-block;
  background-color: ${props => props.theme.colorPrimaryBg};
  /* margin-top: -32px; */
  padding: 2px 6px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export interface IPageWidgetPreviewProps
  extends IWidgetComponentProps<IPageWidget> {}

export function PageWidgetPreview(props: IPageWidgetPreviewProps) {
  return (
    <PageDivideWrapper>
      <PageDividerIndicator />
      <PageDividerLabel>Divisione di pagina</PageDividerLabel>
    </PageDivideWrapper>
  );
}
